var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main"},[_c('keep-alive',{attrs:{"include":"biAreaStatisticClue,biChannelStatisticClue"}},[_c('router-view')],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }